import React, { useState, useEffect, useMemo } from 'react';
import debounce from 'lodash.debounce';
import s from '../styles/CommentEditor.module.css';

const CommentEditor = ({ projectId, initialComment }) => {
  const [comment, setComment] = useState(initialComment || '');
  const [isSaving, setIsSaving] = useState(false);

  // 🔁 Делаем дебаунс один раз
  const debouncedSave = useMemo(() =>
    debounce(async (newComment) => {
      setIsSaving(true);
      try {
        await fetch(`/api/projects/update_projects/${projectId}`, {
          method: 'PATCH',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ comment: newComment }),
        });
      } catch (err) {
        console.error('Ошибка сохранения комментария:', err);
      } finally {
        setIsSaving(false);
      }
    }, 600)
  , [projectId]);

  const handleChange = (e) => {
    const value = e.target.value;
    setComment(value);
    debouncedSave(value); // 👈 вызываем сохранение с задержкой
  };

  useEffect(() => {
    return () => debouncedSave.cancel(); // 🧼 чистим при размонтировании
  }, [debouncedSave]);

  return (
    <div className={s.comment_all}>
      <textarea
        className={s.coment_textarea}
        placeholder="Комментарий..."
        value={comment}
        onChange={handleChange}
      />
      {isSaving && <div className={s.saving}>Сохранение...</div>}
    </div>
  );
};

export default CommentEditor;
